import React from 'react'

import { ReactComponent as DownloadIconFile } from 'assets/icons/download-icon.svg'

import { IconStyles } from '../types'
import { DownloadCustom } from './DownloadIcon.styles'

// import { Container } from './styles';
interface IDownloadIcon extends IconStyles {
  onClick?: any
}
const DownloadIcon: React.FC<IDownloadIcon> = ({
  onClick,
  colorIcon,
  cursor,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  disabled,
  height,
  width,
  filter = false
}) => {
  return (
    <DownloadCustom
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      cursor={cursor}
      onClick={onClick}
      colorIcon={colorIcon}
      disabled={disabled}
      width={width}
      height={height}
      filter={filter}
    >
      <DownloadIconFile />
    </DownloadCustom>
  )
}

export default DownloadIcon
